import { _decorator } from 'cc';
import TableModel from '../../../../../tableEngine/Script/Game/Data/Model/TableModel';
import BaseMachineInfo from './BaseMachineInfo';

const { ccclass } = _decorator;

@ccclass('SimpleMachineInfo')
export default class SimpleMachineInfo extends BaseMachineInfo {
    public updateInfo(tableModel: TableModel): void;
    public updateInfo(machineID: number, machineName: string): void;
    public updateInfo(arg1: TableModel | number, machineName?: string): void {
        const machineID = typeof arg1 === 'number' ? arg1 : arg1.tableID;
        machineName = typeof arg1 === 'number' ? machineName : arg1.machineName;
        if (this.useTwoLabels) {
            this.machineInfoLabel.string = machineName;
            this.machineIDLabel.string = machineID.toString();
        } else {
            this.machineInfoLabel.string = `${machineName} (${machineID})`;
        }
    }
}
